import React, { useState, useEffect, useContext } from "react";
import {
  LoadingOverlay,
  Box,
  Container,
  NativeSelect,
  Alert,
  Select,
  Text,
  TextInput,
  Button,
  Group,
  Stack,
  Center,
} from "@mantine/core";
import { useForm } from "@mantine/form";
import { useMediaQuery } from "@mantine/hooks";
import { DataContext } from "../../../context/DataContext";
import {
  IconShieldCheck,
  IconShieldCancel,
  IconPhoneCheck,
} from "@tabler/icons-react";
import BasicDataCollectionForm from "../../../components/basic-data-collection-form";
import { validateDob } from "../../../utils/validateDob";

export default function IDMatchLegacy() {
  const { text } = useContext(DataContext);

  // Form configuration for COPPA verification
  const formConfig = {
    fields: [
      {
        name: "fn",
        label: text.general.firstName,
        initialValue: "",
        validation: (value) => {
          // Check minimum length
          if (value.length < 2) {
            return text.general.firstNameError;
          }

          // Check for numbers in name
          if (/\d/.test(value)) {
            return "First name cannot contain numbers";
          }

          return null;
        },
      },
      {
        name: "ln",
        label: text.general.lastName,
        initialValue: "",
        validation: (value) => {
          // Check minimum length
          if (value.length < 2) {
            return text.general.lastNameError;
          }

          // Check for numbers in name
          if (/\d/.test(value)) {
            return "Last name cannot contain numbers";
          }

          return null;
        },
      },
      {
        name: "dob",
        label: text.general.DateOfBirth,
        type: "date",
        validation: (value) =>
          validateDob(value, text.general.DateOfBirthError || "Invalid Date of Birth"),
      },
      {
        name: "ssn",
        label: text.general.lastFourSSN,
        initialValue: "",
        // Use our custom masked input instead of password or regular input
        isMaskedInput: true,
        type: "tel", // tel is better than number for this case as it preserves leading zeros
        maxLength: 4,
        pattern: "[0-9]*", // Forces numeric input
        inputMode: "numeric", // Shows numeric keyboard (note: camelCase for React)
        validation: (value) => {
          // Check for non-numeric characters
          if (/[^0-9]/.test(value)) {
            return "SSN must contain only numbers";
          }
          // Check length
          if (value.length !== 4) {
            return text.general.lastFourSSNError;
          }
          return null;
        },
      },
    ],
  };

  return (
    <BasicDataCollectionForm
      config={formConfig}
      title={text.coppa.title}
      subtitle={text.coppa.subTitle}
      buttonText={text.coppa.button}
      icon={<IconShieldCheck size={40} stroke={1.5} />}
      componentKey={"idmatch/coppa"}
      endpoint="/v3/stable/api/frontend/idmatchCoppa"
      reAttempts={2}
    />
  );
}
